export const handleSlippage = (slippage: number, currentPrice: number) => {
  const minPrice = (1 - slippage) * currentPrice;
  const maxPrice = (1 + slippage) * currentPrice;
  const isPriceInRange = currentPrice > minPrice && currentPrice < maxPrice;

  return {
    shouldUpdatePrice: !isPriceInRange,
  };
};
